import { Directive, inject, input, TemplateRef } from '@angular/core';

@Directive({
    selector: 'ng-template[slGridColumn]',
    standalone: false
})
export class GridColumnDirective {
    /**
     * Column's name.
     */
    readonly slGridColumn = input<string>();

    readonly templateRef = inject(TemplateRef<any>);
}
